const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "1.8676053mm",
    height: "1.6792277mm",
    viewBox: "0 0 1.8676053 1.6792277",
    id: "svg14406",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "up_line.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs14400"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14378"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      strokeWidth: 0.26458332
    },
    id: "rect14380",
    width: 1.8676053,
    height: 1.7091703,
    x: -89.611763,
    y: 147.98387
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14382"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      strokeWidth: 0.26458332
    },
    id: "rect14384",
    width: 1.8676053,
    height: 1.7091703,
    x: -89.611763,
    y: 147.98387
  }))), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 3.5293328,
    "inkscape:cy": 3.1733438,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14403"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(82.198684,-147.99372)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(7.4130794,-1.6666665e-6)",
    d: "m -89.031637,149.66942 h 4.07917 l -1.080559,-1.43228 -2.210152,0.0494 -0.788459,1.38289",
    style: {
      fill: "#4c4a49",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    id: "path990",
    "inkscape:connector-curvature": 0,
    clipPath: "url(#clipPath14382)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(7.4130794,-1.6666665e-6)",
    d: "m -95.210539,149.49656 h 6.114697 l 0.82303,-1.32645 h 2.396067 l 0.881945,1.32645 h 7.445022 l 0.837847,-1.32645 h 7.827433 l 0.837846,1.32645 h 0.72743",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277775,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path994",
    "inkscape:connector-curvature": 0,
    clipPath: "url(#clipPath14378)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLine);
export default __webpack_public_path__ + "static/media/up_line.666f2c9693352769df4f13e0e15d888e.svg";
export { ForwardRef as ReactComponent };